import React  from 'react';
import { AuthConsumer } from '../context';

const protectedComponent = (Component, FallbackComponent = null) => (
  <AuthConsumer>
    {({ adminCheck }) => (adminCheck() ? Component : FallbackComponent)}
  </AuthConsumer>
);

export default protectedComponent;
